import { ChangeDetectorRef, Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { NotificationAppType } from '../../../../../shared/enum/authorize';
import { ModalComponent } from '../../../../../shared/widgets/modal/modal.component';
import { environment } from '../../../../../environments/environment';
import { ComponentService } from '../../../../../shared/abstract/component.service';
import { RequestService } from '../../../../../shared/services/request.service';
import { TspVrpInProgressModel } from '../../../../../shared/model/tspVrpInprogressData-model';
import { ExcelCalculationModel } from '../../../../../shared/model/excel-calculation-model';
import { VrpOperations } from '../../../../../shared/enum/vrp-operation-enum';
import { SidemenuComponent } from '../../sidemenu/sidemenu.component';
import { FormType } from '../../../../../shared/enum/form-type';
import { FileManagerService } from '../../../../../shared/services/file-manager.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent extends ComponentService<any> implements OnDestroy, OnInit {
  @ViewChild("menu") menu!: MatMenu;
  subscription!: Subscription;
  notificationBadge!: number;
  notificationEnum = NotificationAppType;
  isMenuClosed = false;
  notifactionList: any[] = [];
  notificationCounterIn = 0;
  baseUrl = environment.apiUrl;
  tspVrpModel: TspVrpInProgressModel | null = null;
  excelCalculationModel: ExcelCalculationModel | null = null;;
  //responseNotific;
  control: boolean = true;
  notifSub!: Subscription;
  //routerLinkDesc;
  constructor(
    injector: Injector,
    private _dialog: MatDialog,
    private _notifService: NotificationService,
    //private _service: Client,
    private _bottomSheet: MatBottomSheet,
    private _router: Router,
    private _request: RequestService,
    private cdr: ChangeDetectorRef,
    private fileManager: FileManagerService
  ) {
    super(injector);
    const source = interval(15000);
    this.subscription = source.subscribe(val => {
      if (this.control) {
        this.getNotificationsBadge().then(res => {
          res != undefined ? this.control = true : this.control = false;
        })
      }
    });
  }

  ngOnInit() {

    this.getNotificationsBadge();


  }


  ngAfterViewInit() {
    this.menu.close.subscribe(x => {
      this.isMenuClosed = true;
      this.notificationClosed();
    });
  }


  async notificationClosed() {

    this._request.updateNotifications(this.notifactionList).then(res => {
      if (res) {

      }

    })
  }


  ngOnDestroy() {
    
  }

  toggleBadgeNotifications() {
    var companyId = this._appsService.selectedCompany
    var projectId = this._appsService.selectedProject
    Promise.all([
      this._request.getNotifications(),
      this._request.getInProgressTspVrpData(companyId, projectId),
      this._request.getInProgressExcel(companyId, projectId)
    ]).then(([notifications, tspVrpData, inProgresExcel]) => {
      this.notifactionList = notifications;
      this.tspVrpModel = tspVrpData;
      this.excelCalculationModel = inProgresExcel;
      this.notificationBadge = 0;
      this.cdr.detectChanges();
    }).catch(error => {
      console.error("Error fetching data:", error);
    });
    this._appsService.logInfo("Bildirimler görüntülendi");
  }



  async getRouter(notif): Promise<any> {
    //var url = this.getUrl(notif);
    if (notif.notificationTypeId.toString() == NotificationAppType.CalculateTsp.toString() || notif.notificationTypeId.toString() == NotificationAppType.CalculateTsp.toString()) {
      this._appsService.rightSidebarControl.next({ state: 'close', type: FormType.Team, operation: 'update' });

      this._router.navigate(['application/workforce']);

      const dialogRef = this._dialog.open(ModalComponent, {
        data: {
          type: 'tspMessage',
          title: 'calculationResult',
          cancel: 'cancel',
          ok: 'confirm',
          color: 'warn',
          data: notif.body
        }
      });

      dialogRef.afterClosed().subscribe(() => {

        setTimeout(() => {
          this._appsService.rightSidebarControl.next({ state: 'open', type: FormType.Team, operation: 'update', transactionGuid: notif.calculationId, notificationTspControl: true });
          this._appsService.notificationTspVrpControl.next({ calculationId: notif.calculationId, notificationTypeId: notif.notificationTypeId });
        }, 1000)
      });


    }
    else if (notif.notificationTypeId.toString() == NotificationAppType.ExcelImportType.toString() || notif.notificationTypeId.toString() == NotificationAppType.Report.toString()) {

      if (notif.fileId) {
        try {
          let suggestedName: string | undefined = undefined;
          if (notif.body) {
            const match = notif.body.match(/[^\/\\]+$/);
            if (match) {
              suggestedName = match[0];
            }
          }
          
          await this.fileManager.downloadFileById(notif.fileId, suggestedName);


          if (notif.notificationTypeId.toString() == NotificationAppType.ExcelImportType.toString()) {
            const dialogRef = this._dialog.open(ModalComponent, {
              panelClass: 'dialog-responsive',
              maxWidth: '100vw',
              data: {
                type: 'bulk-import-result',
                title: 'excelImportResult',
                cancel: 'cancel',
                ok: 'confirm',
                color: 'warn',
                data: notif.body
              }
            });
          }
        } catch (error) {
          this.MessageBox(this.languageKey('chat.fileDownloadFailed') || 'Dosya indirilemedi', 'warn', 'center');
        }
      } else {
        const isValidExcelEndpoint = /^Resources[\\/]{1}ExcelImports[\\/]{1}.+\.xlsx$/i.test(notif.body);
        const isValidExcelEndpointWithReportPath = /^Resources[\\/]{1}Reports[\\/]{1}.+\.xlsx$/i.test(notif.body);
        const isValidPdfEndpointWithReportPath = /^Resources[\\/]{1}Reports[\\/]{1}.+\.pdf$/i.test(notif.body);
        
        if (isValidExcelEndpoint) {
          window.location.href = this.baseUrl + '/' + notif.body;

          const dialogRef = this._dialog.open(ModalComponent, {
            panelClass: 'dialog-responsive',
            maxWidth: '100vw',
            data: {
              type: 'bulk-import-result',
              title: 'excelImportResult',
              cancel: 'cancel',
              ok: 'confirm',
              color: 'warn',
              data: notif.body
            }
          });
        } else if(isValidExcelEndpointWithReportPath){
            window.location.href = this.baseUrl + '/' + notif.body;

        } else if(isValidPdfEndpointWithReportPath){
            window.open(this.baseUrl + '/' + notif.body, '_blank');
        }
      }



    }
    else if (notif.notificationTypeId.toString() == NotificationAppType.CalculateVrp.toString()) {
      this._router.navigate(['application/workforce']).then(() => {

        setTimeout(() => {
          this._appsService.notificationTspVrpControl.next({
            calculationId: notif.calculationId,
            notificationTypeId: notif.notificationTypeId
          });

          this._appsService.sideMenuOpenControl.next({
            notificationTypeId: notif.notificationTypeId,
            formType: FormType.Work
          });
        }, 700);
      });
    }
    
    else {
      /*this._router.navigate(['app/' + url]);*/
    }
    this._appsService.logInfo("Bildirim detayı görüntülendi");
  }

  showAllNotifications() {

    const dialogRef = this._dialog.open(ModalComponent, {
      data: {
        type: 'show-notifications',
        title: 'notifications',
        cancel: 'cancel',
        ok: 'confirm',
        color: 'warn',
        data: this.notifactionList
      }
    });



  }

  onMouseEnter(event: Event): void {
    const target = event.target as HTMLElement;
    target.style.backgroundColor = '#00A1FF'; // Blue background
    target.style.color = 'white';           // White text color
  }

  onMouseLeave(event: Event): void {
    const target = event.target as HTMLElement;
    target.style.backgroundColor = '#FFFFFF'; // Revert to white background
    target.style.color = '#777777';           // Revert to black text color
  }


  async getNotificationsBadge() {
    return await this._request.getNotificationsCount().then(async data => {

      return this.notificationBadge = data;
    })
  }



  getUrl(notif): any {
    switch (notif.notificationTypeId.toString()) {
      case NotificationAppType.NotesType.toString():
        return 'notes/notes-management';
      case NotificationAppType.MailType.toString():
        return 'notices/notices-list';
      case NotificationAppType.ChartType.toString():
        return 'dashboard';
      case NotificationAppType.Report.toString():
        //window.location.href = this.baseUrl + '/' + notif.body;
        return 'report';
      case NotificationAppType.ExcelImportType.toString():
        //window.location.href = this.baseUrl + '/' + notif.body;
        return 'work-force';

      default:
        return '';
    }
  }
  localizeCalculationType(typeId) {
    if (typeId == 1) {
      return this.languageKey('calculationVrp');
    }
    else if (typeId == 2) {
      return this.languageKey('calculationTsp');
    }
  }
  calculationCancel(id) {
    this._request.tspVrpCalculationCancel(id).then(x => {
      if (x.code = 200) {
        this.MessageBox(x.message, 'primary', 'center');
      }
      else {
        this.MessageBox(x.message, 'orange', 'center');
      }
      //this.MessageBox(this.languageKey('formNotFound'), 'orange', 'center');    
    });
    this._appsService.logInfo("TSP hesaplaması iptal edildi");
  }
  calculationExcelCancel(id) {
    this._request.inProgressExcelCancel(id).then(x => {
      if (x.code = 200) {
        this.MessageBox(x.message, 'primary', 'center');
      }
      else {
        this.MessageBox(x.message, 'orange', 'center');
      }
      //this.MessageBox(this.languageKey('formNotFound'), 'orange', 'center');    
    });
    this._appsService.logInfo("Excel hesaplaması iptal edildi");
  }
}
